import styled from 'styled-components';
import { mixins } from '@sy/component-library';

const { media } = mixins;

export const ConclusionWrapper = styled.div`
	width: 100%;
	padding: 96px 24px;
	background-color: ${({ theme }) => theme.colors.grey[100]};

	${media.belowLarge`
		padding: 48px 24px;
	`}
`;

export const ConclusionContent = styled.div`
	width: 100%;
	max-width: 864px;
	margin: 0 auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	gap: 24px;
`;

export const ConclusionTitle = styled.h1`
	font-weight: 700;
	font-size: 3.2rem;
	line-height: 3.8rem;
	color: ${({ theme }) => theme.colors.grey[900]};
	margin: 0;
`;

export const ConclusionText = styled.span`
	text-align: center;
	font-weight: 600;
	font-size: 1.8rem;
	line-height: 2.7rem;
	color: ${({ theme }) => theme.colors.grey[900]};
	white-space: pre-line;
`;
